import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    controlDeviceEligiblePackageVersionsSelector,
} from '~/features/devices/selectors/controlDeviceSelectors';

import noop from 'lodash/fp/noop';
import uid from '~/features/base/utils/uid';
import DeviceDeliverables from '~/features/oldVehicles/components/devices/DeviceDeliverables';

/**
 * Container for the device artifacts
 */
export class DeviceDeliverablesContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.name = uid();
    }

    render() {
        const { controlDeviceInfo, controlDeviceEligiblePackageVersions } = this.props;
        return (
            <DeviceDeliverables controlDeviceInfo={controlDeviceInfo}
                                controlDeviceEligiblePackageVersions={controlDeviceEligiblePackageVersions}/>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    return {
        controlDeviceEligiblePackageVersions: controlDeviceEligiblePackageVersionsSelector(state, ownProps),
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDeliverablesContainer);

DeviceDeliverablesContainer.defaultProps = {
    // props
    serialNumber: '',
    controlDeviceInfo: undefined,
    controlDeviceEligiblePackageVersions: undefined,
    // functions
    registerDataInterest: noop,
    unregisterDataInterest: noop,
    triggerDataFetcher: noop,
};

DeviceDeliverablesContainer.propTypes = {
    // props
    serialNumber: PropTypes.string,
    controlDeviceInfo: PropTypes.object,
    controlDeviceEligiblePackageVersions: PropTypes.object,
    // functions
    registerDataInterest: PropTypes.func,
    unregisterDataInterest: PropTypes.func,
    triggerDataFetcher: PropTypes.func,
};
